import type { RoleConfig } from '../types.js';

export const arsonist: RoleConfig = {
  id: 'arsonist',
  faction: 'solo',
  title: { ru: 'Поджигатель', uk: 'Палій' },
  latin: 'ARSONIST',
  number: '09',
  accent: '#ff7a1a',
  sub: '#8a3a0a',
  ability: {
    ru: 'Каждую ночь обливает игрока. Когда хочет — поджигает всех облитых.',
    uk: 'Щоночі обливає гравця. Коли хоче — підпалює всіх облитих.',
  },
  abilities: [
    {
      key: 'douse',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: false,
    },
    {
      key: 'ignite',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: false,
      targetless: true,
    },
  ],
  victory: { type: 'solo-burn-all-doused' },
};
